import { useNavigate } from "react-router-dom";
import * as Icons from "lucide-react";
import { useAuth } from "@/lib/auth";
import { BRAND } from "@/brand.config";
import { useApi } from "@/pages/admin/control_centre/_kit";

export default function SuiteHome() {
  const { data } = useApi("/modules");
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const mods = data?.modules || [];
  return (
    <div className="min-h-screen bg-[#F6F3EC]" data-testid="suite-home">
      <header className="bg-[#141414] text-white">
        <div className="max-w-7xl mx-auto px-8 py-8 flex items-end justify-between">
          <div>
            <div className="flex items-center gap-3"><img src={BRAND.logoWhiteUrl} alt={BRAND.name} className="h-6 w-auto" data-testid="suite-brand-logo" /><span className="text-[10px] uppercase tracking-[0.35em] text-[#B08D57]">Loyalty, CRM & CX Suite</span></div>
            <h1 className="font-display text-4xl sm:text-5xl mt-2">Module Suite</h1>
            <p className="text-sm text-white/60 mt-2 max-w-xl">Every module is a full application with its own menu, dashboards, reports and configuration. Each opens in its own window; all are joined by one key — the customer's mobile number.</p>
          </div>
          <div className="text-right text-xs text-white/70">
            <div data-testid="suite-user">{user?.name || user?.email} · {user?.role}</div>
            <div className="flex gap-3 mt-2 justify-end">
              <a href="/admin" target="_blank" rel="noreferrer" className="underline hover:text-white" data-testid="suite-classic-admin">Loyalty Engine (full admin) ↗</a>
              <button className="underline hover:text-white" data-testid="suite-logout" onClick={() => { logout(); nav("/enterprise/login"); }}>Sign out</button>
            </div>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-8 py-10">
        <CustomerSearch />
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 mt-8">
          {mods.map((m, i) => {
            const Icon = Icons[m.icon] || Icons.Box;
            return (
              <a key={m.key} href={m.home || `/m/${m.key}`} target="_blank" rel="noreferrer" data-testid={`suite-module-${m.key}`} style={{ animationDelay: `${i * 40}ms` }}
                className={`group bg-white border border-black/10 rounded-sm p-6 transition-[transform,border-color] hover:-translate-y-0.5 hover:border-[#5A1A22] animate-in fade-in slide-in-from-bottom-2 ${m.allowed ? "" : "opacity-50 pointer-events-none"}`}>
                <div className="flex items-start justify-between">
                  <div className="w-10 h-10 rounded-sm bg-[#141414] text-[#B08D57] flex items-center justify-center group-hover:bg-[#5A1A22] transition-colors"><Icon size={18} /></div>
                  <span className="text-[10px] uppercase tracking-[0.2em] text-neutral-400">{m.rules.length} rule set{m.rules.length === 1 ? "" : "s"} · opens in new window ↗</span>
                </div>
                <h2 className="font-display text-xl mt-4">{m.name}</h2>
                <p className="text-xs text-neutral-500 mt-1">{m.tagline}</p>
                <div className="grid grid-cols-4 gap-2 mt-5 pt-4 border-t border-black/5">
                  {m.kpis.map((k) => <div key={k.label}><div className="font-display text-lg tabular-nums leading-none">{k.value}</div><div className="text-[9px] uppercase tracking-[0.12em] text-neutral-400 mt-1 leading-tight">{k.label}</div></div>)}
                </div>
              </a>
            );
          })}
        </div>
      </main>
    </div>
  );
}

function CustomerSearch() {
  return (
    <form className="flex gap-2 max-w-xl" onSubmit={(e) => { e.preventDefault(); const m = new FormData(e.target).get("m"); if (m) window.open(`/m/customer360/profile?mobile=${m}`, "_blank"); }}>
      <input name="m" data-testid="suite-search-mobile" placeholder="Look up any customer by mobile number across all modules…" className="flex-1 border border-black/15 rounded-sm px-4 py-3 text-sm bg-white focus:outline-none focus:border-[#5A1A22]" />
      <button data-testid="suite-search-btn" className="px-5 bg-[#141414] text-white text-xs uppercase tracking-[0.2em] rounded-sm hover:bg-[#5A1A22]">Search</button>
    </form>
  );
}
